import React from "react";
import { useNavigate } from "react-router-dom";
import { EventIcon, describeEvent } from "../../components/EventIcon";

function timeAgo(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const now = new Date();
    const diff = Math.floor((now - d) / 1000);
    if (diff < 60) return "adesso";
    if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} h fa`;
    const days = Math.floor(diff / 86400);
    if (days < 7) return `${days} g fa`;
    return d.toLocaleDateString("it-IT", { day: "numeric", month: "short" });
}

function dayLabel(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yest = new Date(today); yest.setDate(today.getDate() - 1);
    const dOnly = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    if (dOnly.getTime() === today.getTime()) return "OGGI";
    if (dOnly.getTime() === yest.getTime()) return "IERI";
    return d.toLocaleDateString("it-IT", {
        weekday: "long", day: "numeric", month: "short",
    }).toUpperCase();
}

export default function PulseFeed({ items = [], loading = false, onSeeAll = null }) {
    const nav = useNavigate();
    let lastDay = null;

    return (
        <aside className="enl-pulse" data-testid="dashboard-pulse-panel" aria-label="Pulse feed">
            <h2 data-testid="pulse-title">Pulse</h2>
            <div className="enl-pulse-scroll" data-testid="pulse-scroll">
                {loading && <div className="enl-empty">Caricamento…</div>}
                {!loading && items.length === 0 && (
                    <div className="enl-empty" data-testid="pulse-empty">
                        Nessuna attività recente.
                    </div>
                )}
                {items.map((ev) => {
                    const label = dayLabel(ev.timestamp);
                    const showDay = label !== lastDay;
                    lastDay = label;
                    const desc = describeEvent(ev);
                    return (
                        <React.Fragment key={ev.id}>
                            {showDay && (
                                <div className="enl-pulse-day" data-testid={`pulse-day-${label}`}>
                                    {label}
                                </div>
                            )}
                            <div className="enl-pulse-item" data-testid={`pulse-item-${ev.id}`}>
                                <div className="enl-pulse-icon" aria-hidden>
                                    <EventIcon type={ev.event_type} />
                                </div>
                                <div className="enl-pulse-text">
                                    <span className="actor">{ev.actor_name || "Sistema"}</span>{" "}
                                    <span>{desc.verb}</span>{" "}
                                    {desc.objectText && <span>{desc.objectText} </span>}
                                    {ev.client_name && (
                                        <>
                                            <span>per </span>
                                            <button
                                                type="button"
                                                className="company"
                                                onClick={() => ev.client_id && nav(`/app/clienti/${ev.client_id}`)}
                                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", font: "inherit" }}
                                            >
                                                {ev.client_name}
                                            </button>
                                        </>
                                    )}
                                </div>
                                <time className="enl-pulse-time" dateTime={ev.timestamp}>
                                    {timeAgo(ev.timestamp)}
                                </time>
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
            <div className="enl-pulse-fade" aria-hidden />
        </aside>
    );
}
